import { render, staticRenderFns } from "./ResourceAccordion.vue?vue&type=template&id=841ecdae&"
import script from "./ResourceAccordion.vue?vue&type=script&lang=js&"
export * from "./ResourceAccordion.vue?vue&type=script&lang=js&"
import style0 from "./ResourceAccordion.vue?vue&type=style&index=0&id=841ecdae&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports